import { Category } from "../pages/categories/data-view/types";

export const CategoriesData: Array<Category> = [];
